module.exports = __webpack_public_path__ + "img/24_32.5ffbbfc0.png";